// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__container___HW4ZD {
    display: flex;
    justify-content: center;
    align-items: center;
}

.style__imageFile___Q3Ru6 {
    width: 90vh;
    height: 90vh;
    object-fit: contain;
}

.style__placeholder___IH3M2 {
    color: var(--black)
}

.style__progressContainer___Kw7m6 {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: absolute;
    z-index: 1;
}

.style__processing___b0gxL {
    color: white;
    font-weight: bold;
    margin-bottom: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/FileViewItem/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB","sourcesContent":[".container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.imageFile {\n    width: 90vh;\n    height: 90vh;\n    object-fit: contain;\n}\n\n.placeholder {\n    color: var(--black)\n}\n\n.progressContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    position: absolute;\n    z-index: 1;\n}\n\n.processing {\n    color: white;\n    font-weight: bold;\n    margin-bottom: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style__container___HW4ZD`,
	"imageFile": `style__imageFile___Q3Ru6`,
	"placeholder": `style__placeholder___IH3M2`,
	"progressContainer": `style__progressContainer___Kw7m6`,
	"processing": `style__processing___b0gxL`
};
export default ___CSS_LOADER_EXPORT___;
